"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSmartNumpadKeyDown = exports.useSmartNumpad = void 0;
// react-smart-numpad — MIT License © 2025 Christian Giangreco
var useSmartNumpad_1 = require("./useSmartNumpad");
Object.defineProperty(exports, "useSmartNumpad", { enumerable: true, get: function () { return useSmartNumpad_1.useSmartNumpad; } });
var handleSmartNumpad_1 = require("./handleSmartNumpad");
Object.defineProperty(exports, "handleSmartNumpadKeyDown", { enumerable: true, get: function () { return handleSmartNumpad_1.handleSmartNumpadKeyDown; } });
